export const toError = (e: unknown) => (e instanceof Error ? e : new Error(String(e)))
